import compareVs from './compare-vs';

export default {
  init() {
    compareVs();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
